import profile6 from "../assets/bckg7.jpg"
import profile2 from "../assets/bckg8.jpg"
import profile3 from "../assets/bckg9.jpg"
import profile4 from "../assets/bckg12.jpg"
import profile5 from "../assets/bckg11.jpg"

  
  const Recommend = [
    {
        id: 1,
        profileimg: profile6,
        background: profile6,
        profilename: "Joy Ubong",
        mutualFriends: 6,
        jobTitle: "Web Developer",
        desc: "I'd love to change the world, but they wont give me the source code.",
        post: 906,
        followers: 4.5,
        following: 45,
    },
    {
        id: 2,
        profileimg: profile2,
        background: profile2,
        profilename: "Shane Buffer",
        mutualFriends: 16,
        jobTitle: "Product Manager",
        desc: "I'd love to change the world, but they wont give me the source code.",
        post: 56,
        followers: 1.2,
        following:65,
    },
    {
        id: 3,
        profileimg: profile3,
        background: profile3,
        profilename: "Sofia Bush",
        mutualFriends: 23,
        jobTitle: "Cosplayer",
        desc: "I'd love to change the world, but they wont give me the source code.",
        post: 100,
        followers: 1,
        following:169,

    },
    {
        id: 4,
        profileimg: profile4,
        background: profile4,
        profilename: " George Mattew",
        mutualFriends: 2,
        jobTitle: "Software Engineer",
        desc: "I'd love to change the world, but they wont give me the source code.",
        post: 98,
        followers: 1.5,
        following: 90,

    },
    {
        id: 5,
        profileimg: profile5,
        background: profile5,
        profilename: "Isthar Order",
        mutualFriends: 45,
        jobTitle: "Web Developer",
        desc: "I'd love to change the world, but they wont give me the source code.",
        post: 256,
        followers: 2.5,
        following:365,
    },
]

export default Recommend;